import { Button, IconHeartOn16, IconHeartOff16 } from '@cian/ui-kit';
import * as React from 'react';

interface IHeartFavouriteButtonProps {
  isFavourite: boolean;
  onClick(): void;
}

export const HeartFavouriteButton: React.FC<IHeartFavouriteButtonProps> = ({ isFavourite, onClick }) => {
  return (
    <Button
      size="M"
      theme="fill_secondary"
      onClick={onClick}
      beforeIcon={isFavourite ? <IconHeartOn16 color="error_100" /> : <IconHeartOff16 color="primary_100" />}
      data-testid="HeartFavouriteButton"
    />
  );
};
